import { HttpClient } from '../httpClient';
import PlacementRequest from '../requests/placementRequest';
import PlacementResponse from '../responses/placementResponse';
import PlacementsResponse from '../responses/placementsResponse';
import { BaseResponse } from '../responses/baseResponse';;

const httpClient = new HttpClient();

export const getPlacements = async () => {
  return httpClient.get<PlacementsResponse>({
    url: '/v1/placements',
    requiresToken: true,
  });
};


export const getPlacement = async (placementId: number) => {
  return httpClient.get<PlacementResponse>({
    url: `/v1/placements/${placementId}`,
    requiresToken: true,
  });
};

export const getDivisionPlacements = async (divisionId: number) => {
  return httpClient.get<PlacementsResponse>({
    url: `/v1/placements/bydivision/${divisionId}`,
    requiresToken: true,
  });
};

export const createPlacement = async (placementrequest: PlacementRequest) => {
  return httpClient.post<BaseResponse>({
    url: '/v1/admin/placements',
    payload: placementrequest,
    requiresToken: true,
  });
};

export const updatePlacement = async (placementId: number, placementrequest: PlacementRequest) => {
  return httpClient.put<BaseResponse>({
    url: `/v1/admin/placements/${placementId}`,
    payload: placementrequest,
    requiresToken: true,
  });
};

export const deletePlacement = async (placementId: number) => {
  return httpClient.delete<BaseResponse>({
    url: `/v1/admin/placements/${placementId}`,
    requiresToken: true,
  });
};

